<template>
  <List el="xsm" style="padding: 32px">
    <!-- <Text el="h2">{{ $route.params.id }}</Text> -->
    <List el="column-between" class="v-center">
      <Text el="h3" v-if="form">{{ form.name }}</Text>
      <Text el="h3" v-else>Not Found...</Text>
      <Icon name="close" @click="close" />
    </List>
    <Accordion v-if="form != null">
      <List el="column-between xsm" style="align-items: center">
        <List el="column xsm" style="align-items: center">
          <!-- <Icon name="add" /> -->
          <Text el="h5">More details</Text>
        </List>
        <span class="material-icons"></span>
      </List>
      <List el="xsm">
        <Text el="p">Submitted On: {{ formatDate(form.submittedOn) }}</Text>
        <Text el="p">Referral Code: </Text>
        <!-- <div class="tags" v-if="form != null">
          <Text v-for="item in form.tags" :key="item">{{ item }}</Text>
        </div> -->
        <Text el="p">Notes: </Text>
        <textarea type="text" v-model="form.notes" @click.stop></textarea>
        <Btn @click.stop="saveNotes">Save Notes</Btn>
      </List>
    </Accordion>
    <br>
    <Text el="h4">Contact Details</Text>
    <List el="xxsm" v-if="form != null">
      <Text el="p">Name: {{ form.name }}</Text>
      <Text el="p">Phone: {{ form.phone }}</Text>
      <Text el="p">Email: {{ form.email }}</Text>
      <Text el="p">Referral Code: {{ form.referralCode }}</Text>
    </List>
    <List
      el="column-stretch xsm"
      style="margin-top: 32px"
      v-if="form != null && $store.getters.isAdmin"
    >
      <Btn el="2ry" @click="deleteForm(form.id)">Delete</Btn>
      <Btn
        @click="setFormStatus(form.id, 'publish')"
        v-if="form.status == 'draft'"
        >Publish</Btn
      >
      <Btn
        @click="setFormStatus(form.id, 'draft')"
        v-if="form.status == 'publish'"
        >Make Draft</Btn
      >
    </List>
    <!-- <List el="column-stretch xsm">
      <Btn el="2ry">Delete</Btn>
      <Btn>Add Files</Btn>
    </List> -->
  </List>
</template>
<script>
let startsWith = require("lodash/startsWith");
// let forEach = require("lodash/forEach");
import router from "../router";
import { db } from "@/firebase";
import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
// import { getStorage } from "firebase/storage";
import Icon from "@/components/btn/Icon.vue";

// const storage = getStorage();

export default {
  components: {
    Icon,
  },
  data() {
    return {
      window: this.$store.state.main.window,
      user: this.$store.state.main.user,
      main: this.$store.state.main.layout.main,
      section: this.$store.state.main.layout.section,
      form: null,
    };
  },
  watch: {
    "$route.params.id": function () {
      this.getForm();
    },
  },
  methods: {
    assignIcon(type) {
      let t = type.split("/");
      let icon = "description";
      switch (t[0]) {
        case "image":
          icon = "image";
          break;
        case "video":
          icon = "play_circle_filled";
          break;
      }
      return icon;
    },
    formatFilename(item) {
      if (startsWith(item.type, "video")) {
        let nameArr = item.name.split(".");
        nameArr.pop();
        return nameArr.join("");
      } else {
        return item.name;
      }
    },
    formatAddress(address) {
      return `${address.street}, ${address.city}, ${address.state} ${address.zip}`;
    },
    formatDate(date) {
      // const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const d = new Date(date);
      return d.toLocaleString();
    },
    async getForm() {
      let routeParams = this.$route.params.id;
      if (routeParams != null) {
        const docRef = doc(db, "infoSessionForms", this.$route.params.id);
        const docSnap = await getDoc(docRef);
        let data = docSnap.data();
        data.id = docSnap.id;
        this.form = data;
      }
    },
    close() {
      this.closeSection();
      router.push("/dashboard/forms");
    },
    closeSection() {
      this.section.collapse = true;
    },
    async setFormStatus(id, status) {
      const docRef = doc(db, "infoSessionForms", id);
      // Set the "capital" field of the city 'DC'
      await updateDoc(docRef, {
        status: status,
      });
      this.closeSection();
      this.getForm();
    },
    async saveNotes(){
      let x = this;
      const docRef = doc(db, "infoSessionForms", x.form.id);
      // Set the "capital" field of the city 'DC'
      await updateDoc(docRef, {
        notes: x.form.notes,
      });
    },
    async deleteForm(id) {
      let x = this;
      var deletePrompt = prompt('To confirm please type "delete"');

      if (deletePrompt != null && deletePrompt == "delete") {
        // File deleted successfully
        deleteDoc(doc(db, "infoSessionForms", id));
        x.$store.commit("forms/deleteInfoSession", id);
        x.close();
      }
    },
  },
  mounted() {
    this.getForm();
  },
};
</script>
<style lang="scss" scoped>
.tags {
  display: flex;
  flex-wrap: wrap;
}
.tags > * {
  font-size: 12px;
  margin: 3px;
  padding: 3px 13px;
  /* border: 1px solid var(--color-7); */
  justify-self: flex-start;
  border-radius: 100px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.03);
  user-select: none;
  color: var(--color-65);
  -webkit-text-fill-color: currentColor;
}
.tags > .active {
  color: var(--color-white);
  background-color: var(--color-cloud);
}
.file {
  padding: 4px 8px;
  border-radius: 5px;
  display: grid;
  // background-color: var(--color-sky-5);
  grid-auto-flow: column;
  align-items: center;
  text-decoration: none;
  grid-gap: var(--space-xxsm);
  transition: 0.2s;
  justify-content: flex-start;
  font-weight: bold;
}
.file:hover {
  background-color: var(--color-sky-5);
}
textarea{
  padding: 10px;
    background-color: #f1f1f1;
    border-radius: 3px;
    border: 0;
    font-size: 16px;
}
</style>
